/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { BookingDataRequestCreate } from '../model';
// @ts-ignore
import { BookingDataRequestRead } from '../model';
// @ts-ignore
import { BookingDataRequestSMSPreview } from '../model';
// @ts-ignore
import { PaginatedBookingDataRequestReadList } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * OrganisationBookingDataRequestOutgoingApi - axios parameter creator
 * @export
 */
export const OrganisationBookingDataRequestOutgoingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A Booking Data Request can only be created when the status of the Booking == OPEN
         * @summary Create a Booking Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {BookingDataRequestCreate} bookingDataRequestCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestCreate: async (bookingId: string, buyerOrgId: string, bookingDataRequestCreate: BookingDataRequestCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'bookingDataRequestCreate' is not null or undefined
            assertParamExists('orgBookingDataRequestCreate', 'bookingDataRequestCreate', bookingDataRequestCreate)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingDataRequestCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the outgoing Booking Data Requests.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestList: async (bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestList', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The data used for the template is from the latest Booking version.
         * @summary Generates an SMS preview that goes out to the recipient.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestPreviewRetrieve: async (bookingId: string, buyerOrgId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestPreviewRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestPreviewRetrieve', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/preview`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
         * @summary Resend a Data Request SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestResendCreate: async (bookingId: string, buyerOrgId: string, requestId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestResendCreate', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestResendCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('orgBookingDataRequestResendCreate', 'requestId', requestId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/{request_id}/resend`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get details about a single Booking Data Request.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestRetrieve: async (bookingId: string, buyerOrgId: string, requestId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestRetrieve', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('orgBookingDataRequestRetrieve', 'requestId', requestId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/{request_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationBookingDataRequestOutgoingApi - functional programming interface
 * @export
 */
export const OrganisationBookingDataRequestOutgoingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationBookingDataRequestOutgoingApiAxiosParamCreator(configuration)
    return {
        /**
         * A Booking Data Request can only be created when the status of the Booking == OPEN
         * @summary Create a Booking Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {BookingDataRequestCreate} bookingDataRequestCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestCreate(bookingId: string, buyerOrgId: string, bookingDataRequestCreate: BookingDataRequestCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDataRequestRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestCreate(bookingId, buyerOrgId, bookingDataRequestCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the outgoing Booking Data Requests.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestList(bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBookingDataRequestReadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestList(bookingId, buyerOrgId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The data used for the template is from the latest Booking version.
         * @summary Generates an SMS preview that goes out to the recipient.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestPreviewRetrieve(bookingId: string, buyerOrgId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDataRequestSMSPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestPreviewRetrieve(bookingId, buyerOrgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
         * @summary Resend a Data Request SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestResendCreate(bookingId: string, buyerOrgId: string, requestId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestResendCreate(bookingId, buyerOrgId, requestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get details about a single Booking Data Request.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestRetrieve(bookingId: string, buyerOrgId: string, requestId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDataRequestRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestRetrieve(bookingId, buyerOrgId, requestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationBookingDataRequestOutgoingApi - factory interface
 * @export
 */
export const OrganisationBookingDataRequestOutgoingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationBookingDataRequestOutgoingApiFp(configuration)
    return {
        /**
         * A Booking Data Request can only be created when the status of the Booking == OPEN
         * @summary Create a Booking Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {BookingDataRequestCreate} bookingDataRequestCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestCreate(bookingId: string, buyerOrgId: string, bookingDataRequestCreate: BookingDataRequestCreate, options?: any): AxiosPromise<BookingDataRequestRead> {
            return localVarFp.orgBookingDataRequestCreate(bookingId, buyerOrgId, bookingDataRequestCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the outgoing Booking Data Requests.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestList(bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedBookingDataRequestReadList> {
            return localVarFp.orgBookingDataRequestList(bookingId, buyerOrgId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * The data used for the template is from the latest Booking version.
         * @summary Generates an SMS preview that goes out to the recipient.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestPreviewRetrieve(bookingId: string, buyerOrgId: string, options?: any): AxiosPromise<BookingDataRequestSMSPreview> {
            return localVarFp.orgBookingDataRequestPreviewRetrieve(bookingId, buyerOrgId, options).then((request) => request(axios, basePath));
        },
        /**
         * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
         * @summary Resend a Data Request SMS
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestResendCreate(bookingId: string, buyerOrgId: string, requestId: string, options?: any): AxiosPromise<void> {
            return localVarFp.orgBookingDataRequestResendCreate(bookingId, buyerOrgId, requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get details about a single Booking Data Request.
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestRetrieve(bookingId: string, buyerOrgId: string, requestId: string, options?: any): AxiosPromise<BookingDataRequestRead> {
            return localVarFp.orgBookingDataRequestRetrieve(bookingId, buyerOrgId, requestId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgBookingDataRequestCreate operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {BookingDataRequestCreate}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreate
     */
    readonly bookingDataRequestCreate: BookingDataRequestCreate
}

/**
 * Request parameters for orgBookingDataRequestList operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly buyerOrgId: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestList
     */
    readonly pageSize?: number
}

/**
 * Request parameters for orgBookingDataRequestPreviewRetrieve operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewRetrieveRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewRetrieve
     */
    readonly buyerOrgId: string
}

/**
 * Request parameters for orgBookingDataRequestResendCreate operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreate
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreate
     */
    readonly requestId: string
}

/**
 * Request parameters for orgBookingDataRequestRetrieve operation in OrganisationBookingDataRequestOutgoingApi.
 * @export
 * @interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest
 */
export interface OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieve
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieve
     */
    readonly requestId: string
}

/**
 * OrganisationBookingDataRequestOutgoingApi - object-oriented interface
 * @export
 * @class OrganisationBookingDataRequestOutgoingApi
 * @extends {BaseAPI}
 */
export class OrganisationBookingDataRequestOutgoingApi extends BaseAPI {
    /**
     * A Booking Data Request can only be created when the status of the Booking == OPEN
     * @summary Create a Booking Data Request
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestCreate(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestCreateRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.bookingDataRequestCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Returns all the outgoing Booking Data Requests.
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestList(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestListRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestList(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The data used for the template is from the latest Booking version.
     * @summary Generates an SMS preview that goes out to the recipient.
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestPreviewRetrieve(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestPreviewRetrieveRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestPreviewRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This can only occur when a Data Request status == OPEN and it is the latest Data Request against the Booking
     * @summary Resend a Data Request SMS
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestResendCreate(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestResendCreateRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestResendCreate(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get details about a single Booking Data Request.
     * @param {OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestOutgoingApi
     */
    public orgBookingDataRequestRetrieve(requestParameters: OrganisationBookingDataRequestOutgoingApiOrgBookingDataRequestRetrieveRequest, options?: any) {
        return OrganisationBookingDataRequestOutgoingApiFp(this.configuration).orgBookingDataRequestRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }
}
